import { ProfileData } from '../types';
import { userAData } from '../data/userA';
import { userBData } from '../data/userB';

const userCodeMap: { [key: string]: ProfileData } = {
  '903': userAData,
  '904': userBData,
};

const domainUserMap: { [key: string]: ProfileData } = {
  'userA.com': userAData,
  'userB.com': userBData,
  'localhost': userAData, // Default for development
  '127.0.0.1': userAData, // Default for development
};

export const getUserDataByDomain = (domain?: string): ProfileData => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return userAData; // Default fallback for SSR
  }
  
  // First check for user code in URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const userCode = urlParams.get('user');
  
  if (userCode && userCodeMap[userCode]) {
    return userCodeMap[userCode];
  }
  
  // Then check domain
  const currentDomain = domain || window.location.hostname;
  const userData = domainUserMap[currentDomain];
  
  if (userData) {
    return userData;
  }
  
  // Default fallback to userA
  return userAData;
};

export const getCurrentDomain = (): string => {
  if (typeof window === 'undefined') {
    return 'localhost'; // Default for SSR
  }
  return window.location.hostname;
};

export const getSupportedDomains = (): string[] => {
  return Object.keys(domainUserMap);
};